<sb-card [loading]="playlistsloading" [singleHeight]="true">
  <div card-header>
    <div class="d-flex justify-content-start">
      <div class="mr-2 d-flex">
        <sb-local-date-time-input [seconds]="true" [weekNumbers]="true" [initialDate]="from"
                                  [ngClass]="{'alertbox': from && till && from?.value > till?.value}"
                                  (modelChange)="handleDateChangeFrom($event)"></sb-local-date-time-input>

        <div *ngIf="from && till && from?.value > till?.value" class="alert alert-danger"
             style="font-size: .7rem;top: 60px">{{'lang.globals.dateWarning'|translate}}</div>
        <!--<div id="from-box" (click)="changeFrom()" class="cursor-pointer btn btn-outline-primary">
            &nbsp;&nbsp;{{getFrom()}} &nbsp;<fa-icon [icon]="'chevron-up'">
            </fa-icon>
        </div>-->
      </div>
      <div class="mr-2">
        <sb-local-date-time-input [seconds]="true" [weekNumbers]="true" [initialDate]="till"
                                  (modelChange)="handleDateChangeTill($event)"></sb-local-date-time-input>
        <!--<div id="till-box" (click)="changeTill()" class="cursor-pointer btn btn-outline-primary">
            &nbsp;&nbsp;{{getTill()}} &nbsp;<fa-icon [icon]="'chevron-up'">
            </fa-icon>
        </div>-->
      </div>
      <button (click)="playlistRequestDebounced()" class="cursor-pointer btn btn-primary">
        &nbsp;&nbsp;{{'lang.globals.search' | translate}} &nbsp;
      </button>
    </div>
  </div>
  <div card-body>
    <sb-comp-playlist-view *ngIf="!playlistsloading" [sharedPlaylists]="sharedPlaylists" [aggregated]="false"
                           [isInIntegratedContext]="true" [isInDeviceContext]="true">
    </sb-comp-playlist-view>
  </div>
</sb-card>
